/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementsent2Inputs */

const en_roomannouncementsent2 = /** @type {(inputs: Roomannouncementsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announcement sent`)
};

const de_roomannouncementsent2 = /** @type {(inputs: Roomannouncementsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigung gesendet`)
};

/**
* | output |
* | --- |
* | "Announcement sent" |
*
* @param {Roomannouncementsent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementsent2 = /** @type {((inputs?: Roomannouncementsent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementsent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementsent2(inputs)
	return de_roomannouncementsent2(inputs)
});
export { roomannouncementsent2 as "roomAnnouncementSent" }